import { PDFDocument, rgb } from 'pdf-lib';
import { supabase } from '../supabaseClient'; // Use destructuring
import { useState } from 'react';

export default function ReportBuilder({ measurements, onClose, organizationId, projectId }) {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);

  

  const uploadToBucket = async (file, fileName, organizationId, projectId) => {
    try {
      const { data, error } = await supabase.storage
        .from('pdf-reports') // Bucket name
        .upload(`reports/${organizationId}/${projectId}/${fileName}`, file, {
          contentType: 'application/pdf',
          upsert: true,
        });
  
      if (error) throw error;
      return data.path; // Return the file path
    } catch (err) {
      console.error('Error uploading PDF:', err);
      throw err;
    }
  };
  

  const generatePDF = async () => {
    try {
      setIsGenerating(true);
      setError(null);

      const templateUrl = '/BR_68.pdf';
      const templateBytes = await fetch(templateUrl).then((res) => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(templateBytes);
      const page = pdfDoc.getPages()[0];

      const yStart = 505;
      const xDate = 35;
      const xDensity = 195;
      const xSurfaceTemp = 430;
      const rowHeight = 16;

      measurements.forEach((measurement, index) => {
        const y = yStart - index * rowHeight;
        page.drawText(measurement.Density?.toString() || 'N/A', {
          x: xDensity,
          y,
          size: 8,
          color: rgb(0, 0, 0),
        });
        page.drawText(measurement.SurfaceTemp?.toString() || 'N/A', {
          x: xSurfaceTemp,
          y,
          size: 8,
          color: rgb(0, 0, 0),
        });
        page.drawText(
          new Date(measurement.measurement_created_at).toLocaleDateString(),
          { x: xDate, y, size: 8, color: rgb(0, 0, 0) }
        );
      });

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const fileName = `BR68_Report_${Date.now()}.pdf`;

      // Upload to Supabase bucket
      await uploadToBucket(blob, fileName, organizationId, projectId);

      alert('Report saved successfully!');
      onClose(); // Close the modal
    } catch (err) {
      console.error('Error generating report:', err);
      setError('Failed to generate and upload the report.');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-75">
      <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
        <h2 className="text-lg font-medium text-gray-900">Generate BR68 Report</h2>
        <p className="mt-2 text-sm text-gray-700">
          You have selected {measurements.length} measurements. Click "Generate" to create the report.
        </p>

        {error && <p className="mt-2 text-sm text-red-500">{error}</p>}

        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="mr-4 px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900"
          >
            Cancel
          </button>
          <button
            onClick={generatePDF}
            className="px-4 py-2 bg-indigo-600 text-sm font-medium text-white rounded-md hover:bg-indigo-500"
            disabled={isGenerating}
          >
            {isGenerating ? 'Generating...' : 'Generate'}
          </button>
        </div>
      </div>
    </div>
  );
}
